/**
 * Book API endpoints
 */

import type {
  BookListItem,
  BookResponse,
  BookWithTOC,
  BookUploadRequest,
} from "../types";
import { cleanRecordId } from "../utils";
import { fetchAPI } from "./client";
import { apiUpload } from "@/shared/lib/api/client";

// Fixed InputType IDs
export const BOOK_READING_INPUT_TYPE_ID = "book_reading";
export const BOOK_QUIZ_INPUT_TYPE_ID = "book_quiz";

export async function getBooks(limit = 50, offset = 0): Promise<BookListItem[]> {
  return fetchAPI<BookListItem[]>(`/api/reading/books?limit=${limit}&offset=${offset}`);
}

export async function getBook(bookId: string): Promise<BookResponse> {
  return fetchAPI<BookResponse>(`/api/reading/books/${cleanRecordId(bookId)}`);
}

export async function getBookWithTOC(bookId: string): Promise<BookWithTOC> {
  return fetchAPI<BookWithTOC>(`/api/reading/books/${bookId}`);
}

export async function uploadBook(
  file: File,
  metadata: BookUploadRequest
): Promise<BookResponse> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("title", metadata.title);
  if (metadata.author) formData.append("author", metadata.author);
  if (metadata.description) formData.append("description", metadata.description);
  if (metadata.tags) formData.append("tags", metadata.tags.join(","));

  return apiUpload<BookResponse>("/api/reading/books/upload", formData);
}

export async function deleteBook(bookId: string): Promise<void> {
  await fetchAPI(`/api/reading/books/${cleanRecordId(bookId)}`, { method: "DELETE" });
}

export async function reprocessBook(bookId: string): Promise<BookResponse> {
  return fetchAPI<BookResponse>(`/api/reading/books/${bookId}/reprocess`, {
    method: "POST",
  });
}
